import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend, configure } from 'vee-validate'
import * as Rules from '@/utils/validators/rules'
import i18n from './i18n.js'
import * as rules from 'vee-validate/dist/rules'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

Object.keys(Rules).forEach(rule => {
  extend(rule, Rules[rule], {
    ...Rules[rule].options,
    params: Rules[rule].params
  })
})

configure({
  // this will be used to generate messages.
  defaultMessage: (_, values) => i18n.t(`validation.${values._rule_}`, values)
})

// globally using
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
